import { Link } from "react-router-dom";
import { ArrowRight, Cpu, TrendingUp, Users, Lightbulb, CheckCircle, Phone, Rocket, Globe, Database, Zap } from "lucide-react";
import HeroBreadcrumb from "@/components/layout/HeroBreadcrumb";
import { SITE_INFO } from "@/data/siteData";

const SERVIZI = [
  { icon: Cpu, titolo: "Check-up Digitale", desc: "Analisi del livello di maturità digitale dell'impresa con un questionario strutturato e un report personalizzato sulle priorità di intervento." },
  { icon: Zap, titolo: "Industria 5.0 e AI", desc: "Orientamento alle tecnologie abilitanti di Industria 5.0: intelligenza artificiale, IoT, cloud computing, automazione e robotica collaborativa." },
  { icon: Rocket, titolo: "Accompagnamento EDI", desc: "Percorsi personalizzati di trasformazione digitale, con supporto specialistico dall'analisi dei processi fino all'implementazione delle soluzioni." },
  { icon: Globe, titolo: "E-commerce e digitale", desc: "Supporto allo sviluppo di canali di vendita online, strategie di presenza digitale e ottimizzazione della customer experience." },
  { icon: Database, titolo: "Finanziamenti digitali", desc: "Orientamento agli incentivi per la digitalizzazione: voucher, crediti d'imposta (4.0, 5.0), bandi regionali e nazionali." },
  { icon: Users, titolo: "Formazione digitale", desc: "Corsi e webinar su competenze digitali per imprenditori e team aziendali, da livello base ad avanzato." },
];

const BENEFICI = [
  "Check-up digitale gratuito per gli associati",
  "Accesso agli incentivi Transizione 4.0 e 5.0",
  "Credito d'imposta per investimenti tecnologici",
  "Supporto per l'accesso ai voucher per le PMI",
  "Rete di esperti e partner tecnologici qualificati",
  "Formazione su AI, cloud e sicurezza informatica",
];

export default function SpinEdiPage() {
  return (
    <main id="main-content" data-testid="spin-edi-page">
      {/* Hero */}
      <section className="relative h-[300px] md:h-[360px] overflow-hidden">
        <img src="/spin-edi-banner.webp" alt="Spinta Digitale SPIN EDI" className="absolute inset-0 w-full h-full object-cover object-center" />
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(4, 30, 66, 0.72)" }} />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative h-full flex flex-col justify-end pb-10">
          <HeroBreadcrumb />
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
            <div className="flex-1 min-w-0">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed'] mb-2 block">Sportelli di Confcommercio Roma</span>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight">Sportello Innovazione: SPIN EDI</h1>
            </div>

            {/* Bollino C.A.T. — servizio erogato da (stile identico a Sicurezza sul lavoro/Promo.Ter) */}
            <div
              className="shrink-0 inline-flex flex-col items-center gap-1.5 bg-white rounded-2xl px-5 py-3 shadow-lg border border-white/10"
              data-testid="hero-cat-badge"
              aria-label="Servizio erogato da C.A.T. Confcommercio Roma"
            >
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[var(--confcom-text-secondary)] font-['Encode_Sans_Semi_Condensed']">
                Servizio a cura di
              </span>
              <img
                src="/logo-cat.webp"
                alt="C.A.T. Confcommercio Roma"
                className="h-14 sm:h-16 w-auto object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Intro */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <p className="text-lg text-[var(--confcom-text-primary)] font-semibold font-['Encode_Sans_Semi_Condensed'] leading-relaxed mb-5">
                SPIN EDI è lo Sportello per l'INnovazione e la trasformazione digitale delle imprese di Confcommercio Roma, realizzato nell'ambito del progetto EDI (Enterprise Digital Innovation).
              </p>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-4">
                Lo sportello accompagna le piccole e medie imprese del terziario nel percorso di digitalizzazione, dall'analisi della maturità digitale fino all'accesso agli incentivi e all'implementazione delle tecnologie più adatte al proprio modello di business.
              </p>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed">
                Il servizio è <strong className="text-[var(--confcom-text-primary)]">gratuito per gli associati</strong> e si avvale di una rete di esperti qualificati e partner tecnologici selezionati.
              </p>
            </div>
            <div className="h-[340px] rounded-xl overflow-hidden">
              <img src="/spin-edi-banner.webp" alt="Spinta Digitale" className="w-full h-full object-cover object-center" />
            </div>
          </div>
        </div>
      </section>

      {/* Servizi */}
      <section className="py-16 bg-[#EBF5FF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-10">Cosa offre lo sportello</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVIZI.map((item) => {
              const Icon = item.icon;
              return (
                <div key={item.titolo} className="bg-white rounded-xl p-6 border border-[var(--confcom-border)]">
                  <div className="w-10 h-10 bg-[var(--confcom-bg-blue-light)] rounded-xl flex items-center justify-center mb-4">
                    <Icon size={20} className="text-[var(--confcom-blue)]" aria-hidden="true" />
                  </div>
                  <h3 className="text-base font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-2">{item.titolo}</h3>
                  <p className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed">{item.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Benefici + Transizione 5.0 */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            <div>
              <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-5">Perché accedere allo sportello</h2>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-6">
                Digitalizzare la propria impresa non è solo una scelta strategica: è sempre più una condizione necessaria per restare competitivi. Lo Sportello SPIN EDI ti aiuta a farlo nel modo più semplice ed efficiente, sfruttando gli incentivi disponibili.
              </p>
              <div className="space-y-3">
                {BENEFICI.map((b) => (
                  <div key={b} className="flex items-center gap-3">
                    <CheckCircle size={16} className="text-[var(--confcom-blue)] shrink-0" aria-hidden="true" />
                    <span className="text-sm text-[var(--confcom-text-secondary)]">{b}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-[var(--confcom-bg-subtle)] rounded-2xl p-8 border border-[var(--confcom-border)]">
              <div className="flex items-center gap-3 mb-4">
                <Lightbulb size={20} className="text-[var(--confcom-blue)]" aria-hidden="true" />
                <h3 className="text-lg font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed']">Transizione 4.0 e 5.0</h3>
              </div>
              <p className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed mb-4">
                I piani Transizione 4.0 e 5.0 offrono crediti d'imposta per gli investimenti in beni strumentali tecnologici e in formazione. Lo Sportello SPIN EDI ti orienta nell'accesso a questi incentivi.
              </p>
              <ul className="space-y-2 text-sm text-[var(--confcom-text-secondary)]">
                {[
                  "Credito d'imposta beni materiali e immateriali 4.0",
                  "Credito d'imposta Transizione 5.0 (energia + digitale)",
                  "Formazione 4.0 per dipendenti",
                  "Voucher per consulenze specialistiche PMI",
                ].map((v) => (
                  <li key={v} className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-[var(--confcom-blue)] shrink-0" />
                    {v}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Come funziona */}
      <section className="py-16 bg-[#EBF5FF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-10 text-center">Come funziona</h2>
          <div className="grid sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
            {[
              { step: "1", titolo: "Prenota il check-up", desc: "Contattaci per prenotare un appuntamento gratuito con un esperto digitale." },
              { step: "2", titolo: "Analisi e piano d'azione", desc: "Ricevi un report personalizzato con i punti di forza, le aree di miglioramento e le opportunità di incentivo." },
              { step: "3", titolo: "Implementazione", desc: "Accedi ai nostri partner tecnologici e agli incentivi disponibili con il supporto del nostro team." },
            ].map((s) => (
              <div key={s.step} className="bg-white rounded-xl p-6 border border-[var(--confcom-border)] text-center">
                <div className="w-10 h-10 bg-[var(--confcom-blue)] rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-lg font-['Encode_Sans_Semi_Condensed']">{s.step}</div>
                <h3 className="text-base font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-2">{s.titolo}</h3>
                <p className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 relative overflow-hidden">
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(0, 59, 117, 0.95)" }} />
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
          <h2 className="text-2xl md:text-3xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] mb-4">Prenota il tuo check-up digitale gratuito</h2>
          <p className="text-white/80 mb-8">Scopri il livello di maturità digitale della tua impresa e come accedere agli incentivi disponibili.</p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/contatti" className="inline-flex items-center gap-2 bg-white text-[var(--confcom-blue)] px-7 py-3 rounded-md font-bold hover:opacity-90 transition-opacity">
              Prenota ora <ArrowRight size={16} aria-hidden="true" />
            </Link>
            <a href={`tel:${SITE_INFO.phone.replace(/\s/g, "")}`} className="inline-flex items-center gap-2 border-2 border-white/40 text-white px-7 py-3 rounded-md font-semibold hover:opacity-90 transition-opacity">
              <Phone size={16} aria-hidden="true" /> {SITE_INFO.phone}
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
